module.exports = {
  name: 'currency-list',
  listClass: 'results',
  defaultLimit: 100,
  itemIndexes: 'name'
}